import React, { useContext, useState, useMemo } from 'react';

interface IPromptContext {
  forceClosingAlert: boolean;
  setForceClosingAlert: React.Dispatch<React.SetStateAction<boolean>>;
}

const PromptContext = React.createContext<IPromptContext>({
  forceClosingAlert: false,
  setForceClosingAlert: () => undefined,
});

export const PromptProvider: React.FC = ({ children }) => {
  const [forceClosingAlert, setForceClosingAlert] = useState<boolean>(false);
  const value = useMemo(() => {
    return {
      forceClosingAlert,
      setForceClosingAlert,
    };
  }, [forceClosingAlert]);

  return <PromptContext.Provider value={value}>{children}</PromptContext.Provider>;
};

export const usePromptContext = () => {
  const context = useContext(PromptContext);
  if (!context) throw new Error('no <PromptContext> wrapper');
  return context;
};
